export default "__VITE_ASSET__8Y_tzFeM__"